import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { IRouteKeys, setActiveRoute } from "../../application/states/navigation/navigation-slice"
import { useAppDispatch } from "../../presentation/hooks/store-hooks"

export const useNavigationService = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const navigateTo = useCallback((data: {
    route: IRouteKeys
  }) => {
    navigate(data.route)
    dispatch(setActiveRoute({
      route: data.route
    }))
  }, [navigate, dispatch])

  return {
    navigateTo
  }
}